import React from 'react';
import { FaHandsHelping, FaWrench, FaToilet, FaBolt, FaBroom, FaHome, FaHammer, FaPaintRoller, FaCar, FaLeaf, FaSnowflake, FaCogs, FaTv } from 'react-icons/fa';

function ServicesSection() {
  const services = [
    { name: 'Appliance Repair', icon: <FaWrench className="text-blue-500 text-4xl" /> },
    { name: 'Plumbing', icon: <FaToilet className="text-blue-500 text-4xl" /> },
    { name: 'Electrician', icon: <FaBolt className="text-blue-500 text-4xl" /> },
    { name: 'Cleaning', icon: <FaBroom className="text-blue-500 text-4xl" /> },
    { name: 'Roofing', icon: <FaHome className="text-blue-500 text-4xl" /> },
    { name: 'Fencing', icon: <FaHammer className="text-blue-500 text-4xl" /> },
    { name: 'Painting', icon: <FaPaintRoller className="text-blue-500 text-4xl" /> },
    { name: 'Auto Repair', icon: <FaCar className="text-blue-500 text-4xl" /> },
    { name: 'Landscaping', icon: <FaLeaf className="text-blue-500 text-4xl" /> },
    { name: 'HVAC', icon: <FaSnowflake className="text-blue-500 text-4xl" /> },
    { name: 'Mechanics', icon: <FaCogs className="text-blue-500 text-4xl" /> },
    { name: 'TV Installation', icon: <FaTv className="text-blue-500 text-4xl" /> },
  ];

  return (
    <section className="max-w-6xl mx-auto p-6 my-10 bg-white rounded-md shadow-md">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Our Services</h2>
      
      <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
        {services.map((service, index) => (
          <div key={index} className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow hover:bg-gray-200 transition">
            {service.icon}
            <p className="mt-2 text-lg font-medium text-gray-700 text-sm">{service.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
